<template>
	<q-card :class="isMobile ? 'bg-black' : 'bg-white'">
		<q-card-section>
			<q-input
				dense
				outlined
				bg-color="white"
				square
				clearable
				v-model="search"
				type="search"
				:label="$t('search')"
			>
				<template v-slot:prepend>
					<q-icon name="fal fa-search" />
				</template>
			</q-input>
		</q-card-section>

		<q-card-section>
			<q-list bordered separator class="q-mt-md messages">
				<q-item
					clickable
					v-ripple
					v-for="m in filteredMessages"
					:key="m.message_id"
					@click="showMessage(m)"
					class="q-py-md"
					:class="m.opened_date ? 'read' : 'unread'"
				>
					<q-item-section>
						<q-item-label :class="isMobile ? 'text-grey-2' : ''">{{ m.title }}</q-item-label>
						<q-item-label :class="isMobile ? 'text-grey-7' : ''" caption>{{
							$dateUtil.fDateTimeAgo(m.send_date)
						}}</q-item-label>
					</q-item-section>
				</q-item>

				<q-item clickable v-ripple v-if="messages.length === 0" class="q-py-md" :dark="isMobile">
					<q-item-section>
						<q-item-label>{{ $t('there_are_no_messages_available_at_the_moment') }}</q-item-label>
					</q-item-section>
				</q-item>

				<q-item
					clickable
					v-ripple
					v-if="filteredMessages.length === 0 && messages.length > 0"
					class="q-py-md"
					:dark="isMobile"
				>
					<q-item-section>
						<q-item-label>{{
							$t('we_couldnt_find_any_messages_with_the_current_search')
						}}</q-item-label>
					</q-item-section>
				</q-item>
			</q-list>
		</q-card-section>

		<q-dialog :maximized="isMobile" v-model="show_message" @hide="getMessages()">
			<message :message="message" />
		</q-dialog>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</q-card>
</template>

<script>
import Message from 'components/user/Message'
import { mapGetters } from 'vuex'
export default {
	name: 'UserInbox',

	data() {
		return {
			loading: false,
			message: {},
			messages: [],
			search: '',
			show_message: false,
		}
	},

	computed: {
		...mapGetters({
			message_id: 'notifications/message_id',
			redirect_url: 'common/redirect_url',
		}),

		filteredMessages() {
			if (!this.search) return this.messages
			else
				return this.messages.filter((e) =>
					e.title.toUpperCase().includes(this.search.toUpperCase())
				)
		},

		isMobile() {
			return this.$q.platform.is.mobile
		},
	},

	components: {
		message: Message,
	},

	methods: {
		getMessages() {
			this.loading = true

			this.$axios
				.get(`/etraining_messages/messages/`)
				.then((response) => {
					this.messages = response.data
					let id_message = this.message_id ? this.message_id : this.redirect_url.message_id
					if (id_message) {
						let message = this.messages.find((obj) => {
							return obj.message_id == id_message
						})
						if (message) this.showMessage(message)
						this.$store.dispatch('notifications/SET_MESSAGE_ID', [null])
						this.$store.dispatch('common/SET_REDIRECT_URL', [''])
					}
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		showMessage(m) {
			this.loading = true

			this.$axios
				.get(`/etraining_messages/messages/${m.message_id}/`)
				.then((response) => {
					this.message = response.data
					this.show_message = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},
	},

	watch: {
		message_id: function () {
			if (this.messages) this.getMessages()
		},
	},

	created() {
		this.getMessages()
	},
}
</script>

<style lang="scss" scoped>
.messages {
	.unread {
		border-left: 10px $grey-3 solid;
	}
	.read {
		border-left: 10px $secondary solid;
	}
}
</style>
